const { createContext } = require("react");

const firebaseContext = createContext({
  addSdk: () => {},
  activeSDK: [],
})

export default firebaseContext
